import React, { useState } from 'react';
import InviteDesignerModal from './InviteDesignerModal';

interface Context {
    onInvite: () => void;
}

const InviteContext = React.createContext<Context>({
    onInvite: () => {},
});

const InviteContextProvider: React.SFC = ({ children }) => {
    const [isModalEnabled, setModalState] = useState(false);
    const openModal = () => setModalState(true);
    const closeModal = () => setModalState(false);

    return (
        <InviteContext.Provider value={{ onInvite: openModal }}>
            {children}
            {isModalEnabled && (
                <InviteDesignerModal isActive={isModalEnabled} onClose={closeModal} />
            )}
        </InviteContext.Provider>
    );
};

export default InviteContext;
export { InviteContextProvider };



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/InviteContext.tsx